export default __webpack_public_path__ + "static/media/done@3x.3afd0b8c.png";